<template>
  <div class="scroll-parametro px-4">
    <v-row>
      <v-col>
        <div class="primary1--text headline font-weight-bold">PARÂMETROS GERAIS</div>
      </v-col>
    </v-row>

    <ParametrosPerfil class="mt-4" />

    <ParametrosCertificado class="mt-4" />

    <ParametroIniciativa class="mt-4" />

    <div v-for="parametro in parametros" :key="parametro.id">
      <ParametrosNotificacao class="mb-4" :parametro="parametro" />
    </div>

    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>
  
  
  <script>
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'
import ErrorMixin from '@/Mixins/ErrorMixin'

import ParametrosNotificacao from './Shared/ParametrosNotificacao'
import ParametrosPerfil from './Shared/ParametrosPerfil'
import ParametrosCertificado from './Shared/ParametrosCertificado'
import ParametroIniciativa from './Shared/ParametrosIniciativa'

export default {
  mixins: [ErrorMixin],

  components: {
    ParametrosNotificacao,
    ParametrosPerfil,
    ParametrosCertificado,
    ParametroIniciativa
  },

  data() {
    return {
      parametros: []
    }
  },

  beforeMount() {
    this.carregarParametrosNotificacao()
  },

  methods: {
    carregarParametrosNotificacao() {
      const parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)

      parametrosGerais
        .getParametrosNotificacao()
        .then(({ data }) => (this.parametros = data))
        .catch((err) => this.setError(err))
    }
  }
}
</script>
  
  <style lang="sass" scoped>
.scroll-parametro
    width: 80%
    height: 500px
    overflow: hidden auto
    padding-right: 12px
</style>
  